module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('v-server-table', {
    ref: "tripTable",
    attrs: {
      "name": "demo2",
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.edit,
      "loaded": _vm.onLoaded
    }
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-829d3108", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-829d3108"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/trip/UpComingTrip.vue
// module id = 2360
// module chunks = 0